import { NudosButton } from 'components/NudosComponents';
import BordOneToneIcon from 'components/NudosComponents/BordOneToneIcon/BordOneToneIcon';
import { useHistory } from 'react-router-dom';
import { fgDefault } from 'styles/styles.constants';
import { TbordOneToneIcon } from 'components/NudosComponents/BordOneToneIcon/BordOneToneIcon.types';
import './SummarySubmitSection.scss';

interface ISummarySubmitSectionProps {
  areErrors: boolean;
  errorTemplateURL?: string;
  handleReturnToUpload: () => void;
  typeOfSummary?: 'orders' | 'catalog';
}

export const SummarySubmitSection = ({
  areErrors,
  errorTemplateURL,
  handleReturnToUpload,
  typeOfSummary = 'catalog'
}: ISummarySubmitSectionProps) => {
  const { push } = useHistory();

  const buttonContentWithIcon = (text: string, icon: TbordOneToneIcon, color: string) => {
    return (
      <div className="summary-submit-section-button-text">
        <span>{text}</span>
        <BordOneToneIcon variant={icon} customWidth="16px" stroke={color} />
      </div>
    );
  };

  const Button1Text = areErrors
    ? buttonContentWithIcon('Volver al cargue masivo', 'arrowRight', fgDefault)
    : `Ir a ${typeOfSummary === 'catalog' ? 'catálogo' : 'órdenes'}`;
  const Button2Text = areErrors
    ? buttonContentWithIcon('Descargar plantilla con errores', 'download', '#FFF')
    : 'Volver a cargue masivo';

  const handleLinkButton1 = () => (areErrors ? handleReturnToUpload() : push(typeOfSummary === 'catalog' ? '/catalog' : '/order/shopping'));

  const handleLinkButton2 = () =>
    areErrors ? window.open(errorTemplateURL, '_blank') : push('/bulk-upload/type-of-charge');

  return (
    <section className="summary-submit-section">
      <NudosButton
        customWidth={areErrors ? '263px' : '122px'}
        customHeight="44px"
        buttonText={Button1Text}
        handleClick={handleLinkButton1}
        colorPalette="secondary"
      />
      <NudosButton
        customWidth={areErrors ? '263px' : '156px'}
        customHeight="44px"
        buttonText={Button2Text}
        handleClick={handleLinkButton2}
      />
    </section>
  );
};
